import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectAllResources, setSelection } from 'store/actions/tables'
import { openModal } from 'store/actions/modals'
import { ButtonGroup } from 'ui'

import { t } from 'translations'

const TableHeader = ({ name, options, rowActions }) => {
  const dispatch = useDispatch()

  const { [name]: tableOptions } = useSelector(state => state.tables)

  const { header, count, alwaysVisible } = options

  const allSelected = Object.keys(options.selectedResourcesMap).length === count

  return (
    <thead>
      <tr>
        {options.isSelectable ? (
          <th scope="col" className="align-middle d-md-table-cell">
            <button
              className={`btn btn-sm ${allSelected ? 'btn-success' : 'btn-outline-secondary'}`}
              onClick={() => {
                if (allSelected) setSelection(name, {})
                else selectAllResources(name)
              }}
            >
              <i className={`${allSelected ? 'fas fa-check-circle' : 'far fa-circle'}`} />
            </button>
          </th>
        ) : null}
        {header.map(h => {
          // Do not want to see this column
          if (!alwaysVisible && !h.notRemovable && !options.visibleColumn[h.key]) return null
          return (
            <th scope="col" key={`${name}-${h.key}`} className="align-middle">
              {h.label ? t(h.label) : ''}
              {h.renderLabel ? h.renderLabel(h, options) : null}
            </th>
          )
        })}
        {rowActions ? (
          <th scope="col" className="table-sticky-right">
            <ButtonGroup>
              {!header.every(column => column.notRemovable) && (
                <button
                  className="btn btn-secondary btn-sm  text-nowrap"
                  type="button"
                  onClick={() => dispatch(openModal('TableOptionsModal', { tableName: name }))}
                >
                  <i className="fas fa-eye fa-fw" />
                  <span className="ml-1 d-none d-md-inline">{t(`VIEW`)}</span>
                </button>
              )}

              {tableOptions?.exportCSV || tableOptions?.exportPDF ? (
                <>
                  <button
                    className="btn btn-secondary btn-sm text-nowrap"
                    type="button"
                    onClick={() => dispatch(openModal('TableExportModal', { tableName: name }))}
                  >
                    <i className="fas fa-file-download fa-fw" />
                    <span className="ml-1 d-none d-md-inline">{t(`EXPORT`)}</span>
                  </button>
                </>
              ) : null}
            </ButtonGroup>
          </th>
        ) : null}
      </tr>
    </thead>
  )
}

export default TableHeader
